import ActionsForm from '@/shared/mixins/actionsForm'
import approvedisapprove from '../approvedisapprove/approvedisapprove.vue'
import ChangedateofinstallmentRepository from '@/shared/http/repositories/realestate/changedateofinstallment'
import { toast } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'tablechangedate',
  mixins: [ActionsForm],
  components: {
    approvedisapprove
  },
  data () {
    return {
      dataParcela: [],
      selectedParcela: {}
    }
  },
  methods: {
    click (obj) {
      if (obj.status === 2) {
        this.selectedParcela = obj
        this.$refs['modal-approve'].show()
      } if (obj.status === 0) {
        toast.info('Esta solicitação de alteração de data da parcela já foi aprovada.')
      } if (obj.status === 1) {
        toast.info('Esta solicitação de alteração de data da parcela já foi reprovada.')
      }
    },
    onLoad () {
      if (localStoreHelper.solicitacoes.alteracaoDataParcela() != null) {
        this.isFilter = true
        this.filter = localStoreHelper.solicitacoes.alteracaoDataParcela()
      }
      if (this.isFilter) {
        ChangedateofinstallmentRepository.GetRequestsByFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              let newRequestsArray = res.data.data
              let newResponse = res
              this.dataParcela = newRequestsArray
              this.$refs.tableGrid.LoadAllByData(newResponse)
            }
          })
          .catch(() => {})
        return
      }
      ChangedateofinstallmentRepository.GetAll(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(Response => {
          this.dataParcela = Response.data.data
          this.$refs.tableGrid.LoadAllByData(Response)
        })
        .catch(() => {})
    },
    approveRequest (id) {
      ChangedateofinstallmentRepository.AprovarSolicitacao(id)
        .then(res => {
          this.onLoad()
        })
        .catch(() => {})
    },
    dadosclicados (id) {
      ChangedateofinstallmentRepository.Get(id)
        .catch(() => {})
    },
    reproveRequest (id, observacao) {
      let data = {
        obs: observacao
      }
      ChangedateofinstallmentRepository.ReprovarSolicitacao(id, data)
        .then(res => {
          this.onLoad()
        })
        .catch(() => {})
    },
    searchWithFilter (filter, isFilter) {
      this.isFilter = isFilter
      this.filter = filter
      if (!this.isFilter) {
        this.$refs.tableGrid.pagingIndex = 1
        this.$refs.tableGrid.currentPage = 1
      }
      ChangedateofinstallmentRepository.GetRequestsByFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.filter)
        .then(res => {
          if (res.status === 200) {
            let newRequestsArray = res.data.data
            let newResponse = res
            this.dataParcela = newRequestsArray
            this.$refs.tableGrid.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/changedateofinstallment/components/tablechangedate/tablechangedate.js